import { hexColorToRGBA } from '@/views/chart/chart/util'
import { componentStyle, seniorCfg } from '../common/common'
import { BASE_ECHARTS_SELECT, DEFAULT_TOOLTIP } from '@/views/chart/chart/chart'

export function baseMixOption2(chart_option, chart) {
 /* console.log("------chart------",chart)
  console.log("mix222222222 _option----------")
  console.log(chart_option)
  // 处理shape attr
  let customAttr = {}
  const yAxis = JSON.parse(chart.yaxis)



  if (chart.customAttr) {
    customAttr = JSON.parse(chart.customAttr)
    console.log("------------customAttr-------------")
    console.log(customAttr)

    if (customAttr.color) {
      chart_option.color = customAttr.color.colors
    }
    // tooltip
    if (customAttr.tooltip) {
      const tooltip = JSON.parse(JSON.stringify(customAttr.tooltip))
      const reg = new RegExp('\n', 'g')
      tooltip.formatter = tooltip.formatter.replace(reg, '<br/>')
      chart_option.tooltip = tooltip

      const bgColor = tooltip.backgroundColor ? tooltip.backgroundColor : DEFAULT_TOOLTIP.backgroundColor
      chart_option.tooltip.backgroundColor = bgColor
      chart_option.tooltip.borderColor = bgColor
    }
  }
*/
  console.log('-----------',chart.data)
  // 处理data
  if (chart.data) {
    //x轴
   // chart_option.title.text = chart.title
   // chart_option.xAxis.data = chart.data.x
    //        //chart.data.xAxis :时间，年月
    //         //chart.data.yAxis ://非正式客户数，正式客户数，转化率
    //         //chart.data.data:数据:{["1", "2022", "596", "115", "0.19295302"]}//月，年，非正式客户数，正式客户数，转化率
    //console.log("---------chart.data.series----------")
    //console.log(chart.data)
    //1.处理chart_option.xAxis.data=["03月", "01月", "02月", "04月", "05月", "06月", "07月", "08月", "09月", "10月", "11月"],
    //2.处理chart_option.legend.data=["2021-非正式客户数", "2022-非正式客户数", "2021-正式客户数", "2022-正式客户数","2021-转化率"，"2022-转化率"],
    //3.添加多个series
   // for(let y=0;y<chart.data.yAxis;y++){
      //for(let x=0;x<chart.data.)

    //}
   /* let xaxisData=[];
    let xaxisData2=[];
    let legendData=[];




    for(let i=0;i<chart.data.data.length;i++){
      const cdata=chart.data.data[i];
      if(chart.data.xAxis[0]){//默认第一个是X抽
        const xaxis=cdata[0]+chart.data.xAxis[0].name
         xaxisData.push(xaxis);
      }
      if(chart.data.xAxis[1]) {//默认第二个是维度
        const xaxis2=cdata[1]+chart.data.xAxis[1].name
        xaxisData2.push(xaxis2);
      }
    }

    if(chart.data.xAxis[1]){//维度
      xaxisData2.forEach(function (item) {
        for (let j=0;j<chart.data.yAxis.length;j++){
           let ydata=chart.data.yAxis[j];
           const yaxis=item+"-"+ydata.name
          legendData.push(yaxis);
        }
      });
    }

    //处理排序
    if(chart.data.xAxis[0]) {//默认第一个是X抽
      let sort=chart.data.xAxis[0].sort;
      if(sort=='desc'){
        xaxisData.sort((a, b) =>b - a);
      }else{
        xaxisData.sort((a, b) =>a - b);
      }
       //去重
      xaxisData= [...new Set(xaxisData)];
    }

    if(chart.data.xAxis[1]) {//默认第二个是维度
      let sort1=chart.data.xAxis[1].sort;
      if(sort1=='desc'){
        legendData.sort((a, b) =>b - a);
      }else{
        legendData.sort((a, b) =>a - b);
      }
      //去重
      legendData= [...new Set(legendData)];
    }

    console.log(xaxisData,legendData)


    for (let i = 0; i < chart.data.series.length; i++) {
      const y = chart.data.series[i]
      y.type = y.type ? y.type : 'bar'
      // color
      y.itemStyle = {
        color: hexColorToRGBA(customAttr.color.colors[i % customAttr.color.colors.length], customAttr.color.alpha)
      }
      // size
      if (customAttr.size) {
        // bar
        if (y.type === 'bar') {
          if (customAttr.size.barDefault) {
            y.barWidth = null
            y.barGap = null
          } else {
            y.barWidth = customAttr.size.barWidth
            y.barGap = customAttr.size.barGap
          }
        }
        // line
        if (y.type === 'line') {
          y.symbol = customAttr.size.lineSymbol
          y.symbolSize = customAttr.size.lineSymbolSize
          y.lineStyle = {
            width: customAttr.size.lineWidth,
            type: customAttr.size.lineType
          }
          y.smooth = customAttr.size.lineSmooth
        }
        // scatter
        if (y.type === 'scatter') {
          y.symbol = customAttr.size.scatterSymbol ? customAttr.size.scatterSymbol : 'circle'
          y.symbolSize = customAttr.size.scatterSymbolSize ? customAttr.size.scatterSymbolSize : 20
        }
      }
      // label
      if (customAttr.label) {
        y.label = customAttr.label
      }
      chart_option.legend.data.push(y.name)
      i >= yAxis.length ? (y.yAxisIndex = 1) : (y.yAxisIndex = 0)

      y.selectedMode = true
      y.select = BASE_ECHARTS_SELECT
        chart_option.series.push(y)
    }



    chart_option.legend.data=legendData;
    chart_option.xAxis.data=xaxisData;

*/
  }

  componentStyle(chart_option, chart)
  seniorCfg(chart_option, chart)
  console.log(JSON.stringify(chart_option))
  return chart_option
}
